import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visita-tarea',
  templateUrl: './visita-tarea.component.html',
  styleUrls: ['./visita-tarea.component.css']
})
export class VisitaTareaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
